const messages = {
  en: {
    subject: "Subject",
    active: "Active",
    clearVal: "Clear form",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    submit: "Submit",
  },
  ru: {
      subject: "Предмет",
      active: "Активный",
      clearVal: "Очистить",
      edit: "Править",
      delete: "Удалить",
      save: "Сохранить",
      submit: "Oтослать",
  }
};

export default messages;